import {
  NEW_SECTION_CODE,
  RETURNS_ANNEXURE_LIST,
  RETURNS_CHALLAN_LIST,
  RETURNS_DOWNLOAD_EXCEL,
  RETURNS_DOWNLOAD_FILES,
  RETURNS_DOWNLOAD_LIST,
  RETURNS_EDIT_ANNEXURE,
  RETURNS_EDIT_CHALLAN,
  RETURNS_FORM,
  RETURNS_FORM_EDIT,
  RETURNS_FVU_GENERATE,
  RETURNS_GENERATE_FILE,
  RETURNS_LIST,
  RETURNS_QUARTERS,
  RETURNS_REFRESH,
  RETURNS_TYPES,
} from '../endpoints/apiEndpoints'
import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from './apiUtils'

export const getReturnsFormList = async payload => {
  const url = urlBuilder(RETURNS_LIST)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getReturnsFormData = async payload => {
  const url = urlBuilder(RETURNS_FORM)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const saveRetursForm = async payload => {
  const url = urlBuilder(RETURNS_FORM_EDIT)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

// challan

export const getReturnsChallanList = async payload => {
  const url = urlBuilder(RETURNS_CHALLAN_LIST)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const editReturnsChallanList = async payload => {
  const url = urlBuilder(RETURNS_EDIT_CHALLAN)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getReturnsAnnextureList = async payload => {
  const url = urlBuilder(RETURNS_ANNEXURE_LIST)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const editReturnsAnnextureList = async payload => {
  const url = urlBuilder(RETURNS_EDIT_ANNEXURE)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getReturnsTypes = async () => {
  const url = urlBuilder(RETURNS_TYPES)
  const requestHeader = buildRequestHeader('GET')
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getQuartersTypes = async () => {
  const url = urlBuilder(RETURNS_QUARTERS)
  const requestHeader = buildRequestHeader('GET')
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const generateRegularFile = async payload => {
  const url = urlBuilder(RETURNS_GENERATE_FILE)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getDownloadFilesList = async payload => {
  const url = urlBuilder(RETURNS_DOWNLOAD_LIST)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadReturnsFile = async (payload, uuid) => {
  const url = urlBuilder(RETURNS_DOWNLOAD_FILES, { uuid })
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadReturnsFileExcel = async payload => {
  const url = urlBuilder(RETURNS_DOWNLOAD_EXCEL)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const refreshReturnsData = async payload => {
  const url = urlBuilder(RETURNS_REFRESH)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const returnsFvuGenerate = async (payload, fileId) => {
  const url = urlBuilder(RETURNS_FVU_GENERATE, { fileId })
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const getNewSectionCodes = async () => {
  const url = urlBuilder(NEW_SECTION_CODE)
  const requestHeader = buildRequestHeader('GET')
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}
